import * as React from 'react';

import {List} from '@common/typescript/objects/List';

import AreaHeader from '@app/components/UI/Area-blocks/AreaHeader/AreaHeader';
import CardResource from '@app/components/UI/CardResource/CardResource';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import {Area} from '@app/objects/Area';
import {rest} from '@app/components/Api';
import {LocalResource} from '@app/objects/LocalResource';

const AreaResources: React.FC<Area> = (area) => {
	const [localResources, setLocalResources] = React.useState<LocalResource[]>();

	React.useEffect(() => {
		rest.get<List<LocalResource>>(`v1/areas/${area.id}/localResources`)
			.then((res) => {
				setLocalResources(res.list);
			});
	}, []);

	return (
		<>
			<div className="area">
				<AreaHeader area={area}/>

				<MiddleText title={'Local resources'} text={"If you're seeking additional help and guidance for your pet, you're in good hands. Check out these reputable organizations in your area."}/>

				<div className="card-resource-wrapper">
					{localResources && localResources.map((resource, index) => (
						<CardResource key={index} url={resource.url} position={resource.title} name={resource.description} phone={resource.phone}/>
					))}
				</div>
			</div>
		</>
	);
};

export default AreaResources;